import { ErrorInRoute } from "@core/presentation/components/routing/error-in-route/error-in-route.component.tsx";
import { Route } from "react-router";

enum stationsPaths {
    STATION = "/station",
    MAP = "/map",
    DETAIL = "/detail",
    SEARCH = "/search",
    SELECTION = "/selection",
}

export const StationRoutes = {
    STATION: stationsPaths.STATION,
    MAP_MOBILE: `${stationsPaths.STATION}${stationsPaths.MAP}`,
    DETAIL_MOBILE: `${stationsPaths.STATION}${stationsPaths.DETAIL}`,
    SEARCH_MOBILE: `${stationsPaths.STATION}${stationsPaths.SEARCH}`,
    SELECTION_MOBILE: `${stationsPaths.STATION}${stationsPaths.SELECTION}`,
} as const;

export const stationRoutes = (
    <Route
        errorElement={<ErrorInRoute />}
        lazy={async () => {
            const { StationModuleLayout } =
                await import("@station/presentation/layout/station-module.layout.tsx");
            return { Component: StationModuleLayout };
        }}
    >
        <Route
            path={stationsPaths.STATION}
            lazy={async () => {
                const { StationResponsivePage } =
                    await import("@station/presentation/pages/station/station-responsive.page.tsx");
                return { Component: StationResponsivePage };
            }}
        />
        <Route
            path={StationRoutes.MAP_MOBILE}
            lazy={async () => {
                const { StationMapMobilePage } =
                    await import("@station/presentation/pages/station/mobile/map/station-map-mobile.page.tsx");
                return {
                    Component: StationMapMobilePage,
                };
            }}
        />
        <Route
            path={StationRoutes.DETAIL_MOBILE}
            lazy={async () => {
                const { StationDetailMobilePage } =
                    await import("@station/presentation/pages/station/mobile/detail/station-detail-mobile.page.tsx");
                return {
                    Component: StationDetailMobilePage,
                };
            }}
        />
        <Route
            path={StationRoutes.SEARCH_MOBILE}
            lazy={async () => {
                const { StationSearchMobilePage } =
                    await import("@station/presentation/pages/station/mobile/search/station-search-mobile.page.tsx");
                return {
                    Component: StationSearchMobilePage,
                };
            }}
        />
        <Route
            path={StationRoutes.SELECTION_MOBILE}
            lazy={async () => {
                const { StationSelectedMobilePage } =
                    await import("@station/presentation/pages/station/mobile/selected/station-selected-mobile.page.tsx");
                return {
                    Component: StationSelectedMobilePage,
                };
            }}
        />
    </Route>
);
